import { render, staticRenderFns } from "./EbarimtDetailModal.vue?vue&type=template&id=5618e2d8"
import script from "./EbarimtDetailModal.vue?vue&type=script&lang=js"
export * from "./EbarimtDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports